import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EventList from './eventList';
import { Banner } from '../../components';
import { Calendar, Plus } from '@phosphor-icons/react';

const LiveEvent = ({events,handleEdit, handleView, placeholderProps}) => {
  const [eventsAdded, setIsEventsAdded ] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      {events?.length > 0 ? (
        <EventList
          status="live"
          events={events}
          handleView={handleView}
          handleEdit={handleEdit}
          allowViewOnClick={true}
        />
      ) : (
        <> {
          eventsAdded ? 
            ( <Banner
              icon={<Calendar size={32}/>}
              title="No live events!"
              content="Events will be made live after review."
            />
            ):(
              <Banner
                icon={<Calendar size={32}/>}
                title="You haven’t created any events yet!"
                content="Let’s create your first event."
                ctaIcon={<Plus size={20} 
                  color={'white'} />}
                cta="List your event"
                onClick={() => navigate('../event/create')}
                {...placeholderProps}
              />
            )
        }
        
        </>
      )}
    </div>
  )
}

export default LiveEvent;
